var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('header',[_c('editorHeader')],1),_c('main',[_c('editorMain')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }